import { BrowserRouter, Navigate, Route, Routes, useParams } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { SignInPanel } from "./components/SignInPanel";
import { HomePage } from "./pages/HomePage";
import { BookDetailPage } from "./pages/BookDetailPage";
import { PersonalizeFlow } from "./pages/PersonalizeFlow";
import { CartPage } from "./pages/CartPage";
import { CheckoutPage } from "./pages/CheckoutPage";
import { ConfirmPage } from "./pages/ConfirmPage";
import { OrdersPage } from "./pages/OrdersPage";
import { AuthExpiredPage } from "./pages/AuthExpiredPage";

function BookDetailRoute() {
  const { bookId = "lunar" } = useParams<{ bookId: string }>();
  return <BookDetailPage bookId={bookId} />;
}

function PersonalizeRoute() {
  const { bookId = "lunar" } = useParams<{ bookId: string }>();
  return <PersonalizeFlow bookId={bookId} />;
}

function ConfirmRoute() {
  const { orderNumber = "" } = useParams<{ orderNumber: string }>();
  if (!orderNumber) return <Navigate to="/" replace />;
  return <ConfirmPage orderNumber={orderNumber} />;
}

function Shell() {
  return (
    <div className="shell">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/books/:bookId" element={<BookDetailRoute />} />
        <Route path="/personalize/:bookId" element={<PersonalizeRoute />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/:orderNumber" element={<ConfirmRoute />} />
        <Route path="/auth/expired" element={<AuthExpiredPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <SignInPanel />
    </div>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Shell />
      </AppProvider>
    </BrowserRouter>
  );
}
